import type { FC, ReactNode } from 'react'
import type { LText } from '@/lib/localized'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { CmsText } from '@/components/store/cms-text'

export const LogoMark: FC<{ className?: string }> = ({ className }): ReactNode => (
    <svg viewBox='0 0 64 64' className={cn('size-9 shrink-0', className)} aria-hidden='true'>
        <rect width='64' height='64' rx='16' fill='#0e1d3d' />
        <path d='M32 12.5 49 22.25v19.5L32 51.5 15 41.75v-19.5Z' fill='none' stroke='#22d3ee' strokeWidth='5' strokeLinejoin='round' />
        <circle cx='32' cy='32' r='6.5' fill='#ffffff' />
    </svg>
)

interface LogoProps {
    name: LText
    settingsId: string | null
    href?: string
    tone?: 'dark' | 'light'
    className?: string
}

export const Logo: FC<LogoProps> = ({ name, settingsId, href = '/', tone = 'dark', className }): ReactNode => {
    return (
        <Link href={href} className={cn('group inline-flex items-center gap-2.5 rounded-xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cyan-400/30', className)}>
            <LogoMark className='transition-transform duration-300 group-hover:rotate-[-6deg]' />
            <CmsText
                table='site_settings'
                id={settingsId}
                field={name}
                className={cn('text-lg font-bold tracking-tight', tone === 'light' ? 'text-white' : 'text-navy-950')}
            />
        </Link>
    )
}
